import PropTypes from 'prop-types';
import Commons from '../../helpers/Commons';

const DisclaimerSection = ({ disclaimer }) => {
    return (
        <div
            className="disclaimer-section"
            dangerouslySetInnerHTML={{
                __html: `${Commons.purifyDomElement(disclaimer)}`,
            }}
        />
    );
};

DisclaimerSection.propTypes = {
    disclaimer: PropTypes.string,
};

export default DisclaimerSection;